<template>
  <div class="detail">
    <div class="header">
      <div class="left" @click="toIndex()">< 返回</div>
      <div class="span1">
        <span> {{ info.teacherName }}老师 考勤统计</span>
      </div>
      <div class="right"></div>
    </div>
    <div>
      <el-form ref="form" :inline="true" :model="queryParams" label-width="90px">
        <el-form-item label="">
            <el-select
              v-model="queryParams.semester"
              placeholder="选择学年学期"
              class="label"
            >
              <el-option v-for="item in semesterList"  :key="item.id+'semester'" :label="item.label" :value="item.id">
              </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="">
           <el-select
              v-model="queryParams.state"
              clearable
              placeholder="请选择考勤状态"
              class="label"
            >
              <el-option
                v-for="item in stateList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              >
              </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-date-picker 
				   	v-model="queryParams.time"
				   	type="date"
				   	placeholder="请选择上课日期">
				   	</el-date-picker>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" size="small" @click="searchFun"
            >搜索</el-button
          >
        </el-form-item>
      </el-form>
      <div class="table">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="locationName" label="上课地点" align="center">
          </el-table-column>
          <el-table-column prop="courseSection" label="课程节次" align="center">
          </el-table-column>
          <el-table-column prop="attendanceTime" label="考勤时间" align="center">
          </el-table-column>
		      <el-table-column prop="classTime" label="上课时间" align="center">
          </el-table-column>
          <el-table-column prop="attendanceStatus" label="出勤状态" align="center">
            <template slot-scope="scope">
              {{stateObj[scope.row.attendanceStatus] || ''}}
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <!--分页组件-->
          <el-pagination
            background
            :current-page="pageNum"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            :total="totalPage"
            layout="total,prev, pager, next,jumper,sizes"
            @size-change="sizeChangeHandle"
            @current-change="currentChangeHandle"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/api/wisdomSchool/index";
import dayjs from 'dayjs';
export default {
  props: ['info', 'semester', 'time'],
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      totalPage:10,
      queryParams: {
        semester: "",
		    state: "",
        time: "",
        start: "",
        end: "",
      },
      semesterList: [
        {id:'2021-2022_1',label:'2021-2022 上学期'},
        {id:'2021-2022_2',label:'2021-2022 下学期'},
        {id:'2022-2023_1',label:'2022-2023 上学期'},
        {id:'2022-2023_2',label:'2022-2023 下学期'},
        {id:'2023-2024_1',label:'2023-2024 上学期'},
        {id:'2023-2024_2',label:'2023-2024 下学期'},
      ],
      tableData: [],
	    stateList:[
				{id:"0",label:"未打卡",},
				{id:"1",label:"正常",},
			],
      stateObj:{
        '0':'未打卡',
        '1':'正常',
      }
    };
  },
 watch: {
    info: {
      handler: function () {
        this.queryParams.semester = this.semester;
        this.queryParams.start = this.time.start;
        this.queryParams.end = this.time.end;
        this.getDataList();
      },
      deep: true,
    },
  },
  created() {
    // 教师考情统计-明细
    // http://{{gateway-addr}}/app-elective/remote/api/statistics/org/teacher/attendance/detail?platformCode=999999&extOrgId=b97227d46e0811ec980e020315f3f1bd&schoolYearSemester=2021-2022_2&startDate=2022-06-08&endDate=2022-06-10&teacherId=b956e2586e0811ec980e020315f3f1bd&page=1&limit=10
  },
  methods: {
    async getDataList() {
      let time = '';
      if(this.queryParams.time){
        time = dayjs(this.queryParams.time).format('YYYY-MM-DD')
      }
      let params = {
        schoolYearSemester: this.queryParams.semester,
        startDate: this.queryParams.start,
        endDate: this.queryParams.end,
        teacherId: this.info.teacherId,
        attendanceStatus: this.queryParams.state,
        searchDate: time,
        extOrgId: sessionStorage.getItem('orgId'),
        platformCode: sessionStorage.getItem('platformCode'),
        page: this.pageNum,
        limit: this.pageSize,
      };
      var { data, code } = await api.getOrgTeacherAttendanceDetail(params);
      console.log("机构-教师考勤统计-明细", data, code);
      if (code == "0") {
        this.tableData = data.list || [];
        this.totalPage = data.total || 0;
      }
    },
    searchFun() {
      this.pageNum = 1;
      this.getDataList();
    },
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.getDataList();
    },
    currentChangeHandle(val) {
      this.pageNum = val;
      this.getDataList();
    },

    toIndex() {
      this.$emit("to-index");
    },
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.detail {
  width: 100%;
  padding: 0px 30px 30px 30px;
  .header {
    height: 60px;
    line-height: 48px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .span1 {
      font-family: "PingFang SC Bold";
      font-size: 20px;
      color: #000;
      margin-right: 30px;
    }
    .left,
    .right {
      width: 60px;
    }
    .left {
      cursor: pointer;
    }
  }

  ::v-deep .el-form .el-input__inner {
    width: 200px;
    height: 32px;
    border-radius: 3px;
    background: #fff;
    border: 1px solid #ddd;
  }

  ::v-deep .el-table__header tr th {
    background: #f7f7f7;
    box-shadow: 0px 1px 0px #eaeaea;
  }

  ::v-deep .el-date-editor .el-range-separator {
    line-height: 22px;
  }

  .pagination {
    text-align: center;
    margin-top: 30px;
  }
}
</style>
